import { useState } from "react";

export function LoginPage({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = (await res.json()) as { error?: string };
      if (!res.ok) {
        setError(data.error || "Kirjautuminen epäonnistui");
        return;
      }
      onLogin();
    } catch {
      setError("Yhteysvirhe");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Kirjaudu</h1>
        {error && <div className="login-error">{error}</div>}
        <input
          type="email"
          placeholder="Sähköposti"
          value={email}
          onChange={(e) => setEmail((e.target as HTMLInputElement).value)}
          required
          autoFocus
        />
        <input
          type="password"
          placeholder="Salasana"
          value={password}
          onChange={(e) => setPassword((e.target as HTMLInputElement).value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Kirjaudutaan..." : "Kirjaudu"}
        </button>
      </form>
    </div>
  );
}
